<template>
  <div class="rechargeResult">
    <div v-if="success">
      <div class="success-icon">
        <van-icon name="checked" color="#18B75D" size="49" />
        <br />
        充值成功
      </div>
      <div class="content">
        <van-cell-group>
          <van-cell
            title="储值卡号:"
            title-class="cellTitle"
            value-class="cellValue"
            :value="cardInfo.prepaidCardCode"
          />
          <van-cell
            title="充值金额:"
            title-class="cellTitle"
            value-class="cellValue"
            :value="data.amount"
          />
          <van-cell
            title="赠送金额:"
            title-class="cellTitle"
            value-class="cellValue"
            :value="data.giveMoney ? data.giveMoney : 0"
          />
          <van-cell
            title="卡内余额:"
            title-class="cellTitle"
            value-class="cellValue"
            :value="data.finalMoney"
          />
          <van-button type="default" to="cardDetail">返回储值卡</van-button>
        </van-cell-group>
      </div>
    </div>
    <div v-else>
      <div class="success-icon">
        <van-icon name="clear" color="#B71818" size="49" />
        <br />
        充值失败
      </div>
      <div class="content">
        <van-cell-group>
          <van-button type="default" to="cardDetail">返回储值卡</van-button>
          <van-button type="default" @click="toCardRecharge"
            >重新获取二维码</van-button
          >
        </van-cell-group>
      </div>
    </div>
  </div>
</template>

<script>
import "../../assets/css/rechargeResult.less";
import {} from "@/api/card";

export default {
  name: "CardDetail",
  data() {
    return {
      success: true,
      showPopup: false,
      payResult: "",
      data: {},
    };
  },
  components: {},
  created() {
    this.loadComments();
  },
  methods: {
    loadComments() {
      let s = sessionStorage.getItem("shopInfo");
      let c = sessionStorage.getItem("cardInfo");
      this.shopInfo = s ? JSON.parse(s) : "";
      this.cardInfo = c ? JSON.parse(c) : "";

      let r = sessionStorage.getItem("payResult");
      this.payResult = r ? JSON.parse(r) : "";
      this.success = this.payResult.success;
      this.data = this.payResult.data;
    },
    toCardRecharge() {
      this.payResult.rebuild = true;
      sessionStorage.setItem("payResult", JSON.stringify(this.payResult));
      this.$router.push("cardRecharge");
    },
  },
};
</script>


